/**
 * Whether "Select Your Areas & Categories" should create the journey's first
 * row for the user (ARO-7073).
 *
 * Decide only from the masterplan the page just fetched for this journey. The
 * old check ran on whatever masterplan was in the store when the page mounted,
 * which could still be the previously opened journey, so a journey that
 * already had rows got another blank one added on every visit.
 */
export const shouldCreateFirstAreaRow = (masterPlan, masterPlanId) => {
  if (!masterPlan || !masterPlanId) return false;
  if (String(masterPlan.id) !== String(masterPlanId)) return false;
  if (!Array.isArray(masterPlan.areas)) return false;

  // Completed goals are not shown on this page, so a journey whose goals are
  // all completed starts with one empty row, as a brand new journey does.
  return !masterPlan.areas.some((area) => !area?.goal?.completed);
};
